import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    Icon,
    PreviewAltCard,
    Row,
} from "../../../components/Component";
import { useLocation, useNavigate } from "react-router";
import { Form, Spinner } from "reactstrap";
import { useFieldArray, useForm } from "react-hook-form";
import MyInput from "../../../MyComp/UI/form/MyInput";
import { districtDDAPI, listStateDDAPI, listStoreDDAPI } from "../../../api/dropdown";
import { toast } from "react-toastify";
import MySelect from "../../../MyComp/UI/form/MySelect";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import ViewImgAndPdf from "../../ImageFolder/ViewImageAndPdf";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import DateComponent from "../../../MyComp/UI/form/DateComponent";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import { pharmacyDetailsAPI, reviewPharmacyAPI } from "../../../api/pahrmacy";
import { BASE_URL_IMG } from "../../../assets/constants";
import { getZipDetailsAPI } from "../../../api/master/indes";
import useLogout from "../../../hooks/useLogout";
import { updatePharmacy } from "../../../api/pahrmacy";

const PharmacyDetailFormEdit = () => {
    const logout = useLogout();
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const isApproved = location?.state?.isApproved;
    const isPharmacy = location?.state?.isPharmacy;

    const [mode, setMode] = useState(location?.state?.mode || "Add");

    const canEdit = isPharmacy && !isApproved;
    const isFormDisabled = !canEdit || mode === "Approval";
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: false,
            agreed: false,
            medical_qualification: null,
            storeTypeDD: [],
            countryDD: [{ value: "India", label: "India" }],
            country: { value: "India", label: "India" },
            stateDD: [],
            cityDD: [],
            paymentModeDD: [
                {
                    value: "card",
                    label: "Card",
                },
                {
                    value: "cash",
                    label: "Cash",
                },
                {
                    value: "net_banking",
                    label: "Net Banking",
                },
                {
                    value: "upi",
                    label: "UPI",
                },
            ],
            deliveryRadiusDD: [
                {
                    value: "1",
                    label: "1 KM",
                },
                {
                    value: "2",
                    label: "2 KM",
                },
                {
                    value: "3",
                    label: "3 KM",
                },
                {
                    value: "4",
                    label: "4 KM",
                },
                {
                    value: "5",
                    label: "5 KM",
                },
                {
                    value: "6",
                    label: "6 KM",
                },
                {
                    value: "7",
                    label: "7 KM",
                },
                {
                    value: "8",
                    label: "8 KM",
                },
                {
                    value: "9",
                    label: "9 KM",
                },
                {
                    value: "10",
                    label: "10 KM",
                },
            ],

            store_image: null,
            store_img: null,

            pan_image: null,
            pan_img: null,

            drug_img: null,
            drug_image: null,

            aadhaar_f_image: null,
            aadhaar_f_img: null,

            aadhaar_b_image: null,
            aadhaar_b_img: null,

            catalog_image: null,
            catalog_img: null,

            fssai_image: null,
            fssai_img: null,

            cheque_image: null,
            cheque_img: null,

            objectionKeys: [],
            approvedKeys: [],

            degree: [
                {
                    certificate: null,
                    certificate_url: null,
                },
            ],
            // mode: location?.state?.mode || "Add",
            actionType: null,
        },
    });
    const { fields, append, remove } = useFieldArray({
        control,
        name: "degree",
    });
    const [imageOpen, setImageOpen] = useState(false);
    const isLoading = watch("isLoading");
    const data = watch("data");
    const navigate = useNavigate();
    const [actionType, setActionType] = useState(null);
    function parseTimeToDate(timeString) {
        const date = new Date();

        // Check if timeString includes AM/PM
        if (/AM|PM/i.test(timeString)) {
            const [time, modifier] = timeString.split(/ (AM|PM)/i);
            let [hours, minutes] = time.split(":").map(Number);

            if (modifier.toUpperCase() === "PM" && hours < 12) {
                hours += 12;
            }
            if (modifier.toUpperCase() === "AM" && hours === 12) {
                hours = 0;
            }

            date.setHours(hours);
            date.setMinutes(minutes);
        } else {
            // Assume 24-hour format
            const [hours, minutes] = timeString.split(":").map(Number);
            date.setHours(hours);
            date.setMinutes(minutes);
        }

        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }
    useEffect(() => {
        getStoreType();
        // getStateList();
        if (mode === "Edit" || mode === "Approval") {
            getPharmacyDetail();
        }
    }, []);
    useEffect(() => {
        setValue("selectedRow", location?.state?.data);
        if (watch("state") != null) {
            const body = {
                stateId: watch("state")?.value,
            };
            // getDistrict(body);
        }
    }, [watch("state")]);

    const getDistrict = (body) => {
        districtDDAPI(body)
            .then((res) => {
                //const status = decrypt(res.data.status);
                if (res.data.status === true) {
                    toast.clearWaitingQueue();
                    setValue("cityDD", res.data.data);
                    setValue("isLoading", false);
                } else if (res.data.status === false) {
                    setValue("isLoading", false);
                    setValue("cityDD", []);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    setValue("isLoading", false);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                setValue("isLoading", false);
                toast.error(err?.response?.data?.message);
            });
    };
    const getStoreType = (body) => {
        listStoreDDAPI(body)
            .then((res) => {
                //const status = decrypt(res.data.status);
                if (res.data.status === true) {
                    toast.clearWaitingQueue();
                    setValue("storeTypeDD", res.data.data);
                    setValue("isLoading", false);
                } else if (res.data.status === false) {
                    setValue("isLoading", false);
                    setValue("storeTypeDD", []);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    setValue("isLoading", false);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                setValue("isLoading", false);
                toast.error(err?.response?.data?.message);
            });
    };
    const getStateList = (body) => {
        listStateDDAPI(body)
            .then((res) => {
                //const status = decrypt(res.data.status);
                if (res.data.status === true) {
                    toast.clearWaitingQueue();
                    setValue("stateDD", res.data.data);
                    setValue("isLoading", false);
                } else if (res.data.status === false) {
                    setValue("isLoading", false);
                    setValue("stateDD", []);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    setValue("isLoading", false);
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                setValue("isLoading", false);
                toast.error(err?.response?.data?.message);
            });
    };

    const getPharmacyDetail = () => {
        pharmacyDetailsAPI(location?.state)
            .then((res) => {
                //const status = decrypt(res.data.status);
                if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                } else if (res.data.status === true) {
                    toast.clearWaitingQueue();
                    setValue("data", res.data.data);
                    const pharmacyData = res.data.data;
                    // Populate form fields with fetched data
                    setValue("name", pharmacyData.store_name);
                    setValue("email", pharmacyData.email);
                    setValue("mobile", pharmacyData.mobile);
                    setValue("objectionKeys", pharmacyData.keys);
                    setValue("store_type", pharmacyData.store);
                    setValue("pharmacy_license_no", pharmacyData.license_no);
                    setValue("pharmacy_gst_no", pharmacyData.gst_number);
                    setValue("pharmacy_mobile", pharmacyData.mobile);
                    setValue("owner_name", pharmacyData.name);
                    setValue("state", pharmacyData.state);
                    setValue("city", pharmacyData.city);
                    setValue("alt_mobile", pharmacyData.contactNumber);
                    setValue("pin_code", pharmacyData.pincode);
                    setValue("full_address", pharmacyData.address);
                    setValue("delivery_radius", pharmacyData.deleiveryRadius);
                    setValue("min_order_value", pharmacyData.min_order_value);
                    setValue("delivery_charges", pharmacyData.home_deleivery_charge);
                    setValue("longitude", pharmacyData.longitude);
                    setValue("latitude", pharmacyData.latitude);
                    setValue("remark", pharmacyData.remark);

                    if (pharmacyData?.payment_method && watch("paymentModeDD")?.length) {
                        // Split the comma-separated string and trim spaces
                        const selectedValues = pharmacyData.payment_method.split(",").map((v) => v.trim());

                        // Map to the options array
                        const selectedOptions = watch("paymentModeDD").filter((opt) => selectedValues.includes(opt.value));

                        // Set the value for your multi-select
                        setValue("payment_modes", selectedOptions);
                        trigger("payment_modes"); // optional, to trigger validation
                    }

                    setValue("cancellation_policy", pharmacyData.policy);
                    setValue("ifsc", pharmacyData.ifscCode);
                    setValue("upi_id", pharmacyData.upiId);
                    setValue("account_no", pharmacyData.accountNumber);
                    setValue("account_holder_name", pharmacyData.owner_name);
                    setValue("kyc_status", pharmacyData.kyc_status);
                    setValue("status", pharmacyData.status);
                    setValue("store_image", pharmacyData.store_image ? `${BASE_URL_IMG}${pharmacyData.store_image}` : null);
                    setValue("pan_image", pharmacyData.pan ? `${BASE_URL_IMG}${pharmacyData.pan}` : null);
                    setValue("drug_image", pharmacyData.drug_license ? `${BASE_URL_IMG}${pharmacyData.drug_license}` : null);
                    setValue(
                        "catalog_image",
                        pharmacyData.medical_catalog ? `${BASE_URL_IMG}${pharmacyData.medical_catalog}` : null,
                    );
                    setValue("fssai_image", pharmacyData.fassai_license ? `${BASE_URL_IMG}${pharmacyData.fassai_license}` : null);
                    setValue(
                        "cheque_image",
                        pharmacyData.cancelled_check_image ? `${BASE_URL_IMG}${pharmacyData.cancelled_check_image}` : null,
                    );
                    setValue(
                        "aadhaar_f_image",
                        pharmacyData.aadhhar_front ? `${BASE_URL_IMG}${pharmacyData.aadhhar_front}` : null,
                    );
                    setValue("aadhaar_b_image", pharmacyData.aadhhar_back ? `${BASE_URL_IMG}${pharmacyData.aadhhar_back}` : null);

                    const sTime24 = pharmacyData?.start_time; // e.g., "17:30"
                    const parsedTime = sTime24 ? parseTimeToDate(sTime24) : null;
                    const eTime24 = pharmacyData?.end_time; // e.g., "17:30"
                    const parsedETime = eTime24 ? parseTimeToDate(eTime24) : null;
                    setValue("start_time", pharmacyData?.start_time ? new Date(parsedTime) : null);
                    setValue("end_time", pharmacyData?.end_time ? new Date(parsedETime) : null);

                    if (pharmacyData.documents && Array.isArray(pharmacyData.documents)) {
                        // Clear existing fields
                        remove();
                        pharmacyData.documents.forEach((item) => {
                            append({
                                certificate: item.url ? `${BASE_URL_IMG}${item.url}` : null,
                                certificate_url: item.url ? `${BASE_URL_IMG}${item.url}` : null,
                            });
                        });
                    }
                    setValue("isLoading", false);
                } else if (res.data.status === false) {
                    setValue("isLoading", false);
                    setValue("data", []);
                    toast.error(!res.data.message);
                    toast.clearWaitingQueue();
                }
            })
            .catch((err) => {
                setValue("isLoading", false);
                toast.error(err?.response?.data?.message);
            });
    };
    const handleImageOpenPreview = (row) => {
        const imageUrl = `${BASE_URL_IMG}${row?.image}`;
        setValue("image_preview", imageUrl);
        setImageOpen(true);
    };
    const handleImageClose = () => {
        setImageOpen(false);
    };
    useEffect(() => {
        if (watch("pin_code") && watch("pin_code").toString().length === 6) {
            const body = {
                pin_code: watch("pin_code"),
            };
            getZipDetails(body);
        }
    }, [watch("pin_code")]);

    const getZipDetails = (body) => {
        setLoading(true);
        getZipDetailsAPI(body)
            .then((res) => {
                setLoading(false);
                if (res.data.status === true) {
                    const responseData = res.data.data[0];
                    setValue("city", responseData?.district_name);
                    setValue("state", responseData?.state_name);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else if (res.data.status === false) {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message);
            });
    };

    //   const onFormSubmit = (data) => {
    //     if (mode == "Approval" && actionType == "approve") {
    //       const body = {
    //         remark: watch("remark") || "",
    //         keys: [],
    //         pharmacyId: location?.state?.pharmacyId || "",
    //         actionType: "approve",
    //       };
    //       reviewPharmacyAPI(body).then((res) => {
    //         if (res.data.status === true) {
    //           navigate("/pharmacy-list");
    //           toast.success(res.data.message);
    //         }
    //       });
    //     }

    //     if (mode == "Approval" && actionType == "changeRequest") {
    //       const body = {
    //         remark: watch("remark") || "",
    //         keys: watch("objectionKeys") || [],
    //         pharmacyId: location?.state?.pharmacyId || "",
    //         actionType: "declined",
    //       };
    //       reviewPharmacyAPI(body).then((res) => {
    //         if (res.data.status === true) {
    //           navigate("/pharmacy-list");
    //           toast.success(res.data.message);
    //         }
    //       });
    //     }
    //   };
    const onFormSubmit = (data) => {

        // ✅ UPDATE CASE (EDIT MODE)
        if (mode === "Edit") {

            const formData = new FormData();

            formData.append("pharmacyId", location?.state?.pharmacyId || "");

            formData.append("store_name", data?.name || "");
            formData.append("email", data?.email || "");
            formData.append("mobile", data?.pharmacy_mobile || "");
            formData.append("owner_name", data?.owner_name || "");

            formData.append("store_type", data?.store_type?.value || data?.store_type || "");
            formData.append("license_no", data?.pharmacy_license_no || "");
            formData.append("gst_number", data?.pharmacy_gst_no || "");

            formData.append("address", data?.full_address || "");
            formData.append("pincode", data?.pin_code || "");
            formData.append("state", data?.state || "");
            formData.append("city", data?.city || "");

            formData.append("contactNumber", data?.alt_mobile || "");

            // ✅ Convert time properly
            const formatTime = (date) => {
                if (!date) return "";

                const d = new Date(date);
                let hours = d.getHours();
                let minutes = d.getMinutes();

                const ampm = hours >= 12 ? "PM" : "AM";

                hours = hours % 12;
                hours = hours ? hours : 12; // 0 becomes 12

                minutes = minutes < 10 ? "0" + minutes : minutes;

                return `${hours}:${minutes} ${ampm}`;
            };

            formData.append(
                "start_time",
                data?.start_time ? formatTime(data.start_time) : ""
            );

            formData.append(
                "end_time",
                data?.end_time ? formatTime(data.end_time) : ""
            );

            formData.append("latitude", data?.latitude || "");
            formData.append("longitude", data?.longitude || "");

            formData.append("min_order_value", data?.min_order_value || "");
            formData.append("home_deleivery_charge", data?.delivery_charges || "");

            formData.append("account_holder_name", data?.account_holder_name || "");
            formData.append("accountNumber", data?.account_no || "");
            formData.append("ifscCode", data?.ifsc || "");
            formData.append("upiId", data?.upi_id || "");

            formData.append("remark", data?.remark || "");

            // ✅ FILES (only if user uploaded new file)
            const getFile = (val) => {
                if (!val) return null;
                if (val instanceof File) return val;
                if (val?.[0] instanceof File) return val[0];
                return null;
            };

            const storeImg = getFile(data?.store_img);
            const drugImg = getFile(data?.drug_img);
            const fassai_license = getFile(data?.fssai_img);
            const chequeImg = getFile(data?.cheque_img);

            if (storeImg) formData.append("store_image", storeImg);
            if (drugImg) formData.append("drug_license", drugImg);
            if (fassai_license) formData.append("fassai_license", fassai_license
            );
            if (chequeImg) formData.append("cancelled_check_image", chequeImg);

            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1]);
            }
            // ✅ API CALL
            updatePharmacy(formData).then((res) => {
                if (res?.data?.status === true) {
                    toast.success(res.data.message);
                    navigate("/pharmacy-list");
                } else {
                    toast.error(res?.data?.message || "Update failed");
                }
            });

            console.log(formData, "formdata");


            return; // ✅ stop further execution
        }

        // ✅ APPROVAL CASE
        if (mode == "Approval" && actionType == "approve") {
            const body = {
                remark: watch("remark") || "",
                keys: [],
                pharmacyId: location?.state?.pharmacyId || "",
                actionType: "approve",
            };

            reviewPharmacyAPI(body).then((res) => {
                if (res.data.status === true) {
                    navigate("/pharmacy-list");
                    toast.success(res.data.message);
                }
            });
        }

        if (mode == "Approval" && actionType == "changeRequest") {
            const body = {
                remark: watch("remark") || "",
                keys: watch("objectionKeys") || [],
                pharmacyId: location?.state?.pharmacyId || "",
                actionType: "declined",
            };

            reviewPharmacyAPI(body).then((res) => {
                if (res.data.status === true) {
                    navigate("/pharmacy-list");
                    toast.success(res.data.message);
                }
            });
        }
    };


    if (!canEdit && mode === "Edit") {
        return (
            <Content>
                <Block>
                    <h5 style={{ color: "red" }}>Only pharmacy users can edit this record.</h5>
                </Block>
            </Content>
        );
    }
    
    const isRejected = (key) => {
        return watch("objectionKeys")?.includes(key);
    };
    return (
        <>
            <Head title={"Pharmacy Detail"} />
            <Content>
                <BlockHead size={`sm`}>
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                {"Pharmacy details"}
                            </BlockTitle>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="">
                                <Button
                                    color="primary"
                                    outline
                                    className={`  me-n1`}
                                    onClick={() => {
                                        navigate("/pharmacy-list");
                                    }}
                                >
                                    <Icon name={"arrow-left"} />
                                </Button>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <PreviewAltCard>
                        <Form onSubmit={handleSubmit(onFormSubmit)}>
                            <Row>
                                <div className="d-flex gap-5 py-3 mb-3">
                                    {" "}
                                    <h5>{"Basic Details"}</h5>
                                </div>
                                <Col md="4">
                                    <div className={isRejected("name") ? "border border-danger rounded p-1" : ""}>

                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title=" Name"
                                            name="name"
                                            placeholder="Enter Pharmacy Name"
                                            required
                                            disabled={isFormDisabled}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className={isRejected("store_type") ? "border border-danger rounded p-1" : ""}>
                                        <MySelect
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title={" type"}
                                            name={"store_type"}
                                            placeholder={"Select type"}
                                            required
                                            options={watch("storeTypeDD")}
                                            disabled={isFormDisabled}
                                        />
                                    </div>
                                </Col>
                                <Col md="4">
                                    <div className={isRejected("pharmacy_license_no") ? "border border-danger rounded p-1" : ""}>
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="License Number"
                                            name="pharmacy_license_no"
                                            placeholder="Enter Pharmacy License No"
                                            required
                                            disabled={isFormDisabled}
                                        />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("pharmacy_gst_no") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="GST Number"
                                        name="pharmacy_gst_no"
                                        placeholder="Enter Pharmacy GST No"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("pharmacy_mobile") ? "border border-danger rounded p-1" : ""}>
                                    <MyMobile
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={" Mobile"}
                                        name={"pharmacy_mobile"}
                                        placeholder={"Enter pharmacy mobile"}
                                        required
                                        disabled={true}
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="store_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"Image"}
                                        errors={errors}
                                        register={register}
                                        image={"store_img"}
                                        image_url={"store_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        required
                                        approve={mode === "Approval" ? true : false}
                                        size={2048}
                                    />
                                </Col>
                                <h5 className="my-3">{"Additional Details"}</h5>

                                <Col md="4" className={``}>
                                <div className={isRejected("pin_code") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Pin Code"}
                                        name={"pin_code"}
                                        placeholder={"Enter pin code"}
                                        required
                                        min={6}
                                        max={6}
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={``}>
                                <div className={isRejected("city") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"District"}
                                        name={"city"}
                                        placeholder={"Enter city"}
                                        required
                                        disabled={isFormDisabled}
                                        readonly
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={``}>
                                <div className={isRejected("state") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"State"}
                                        name={"state"}
                                        placeholder={"Enter state"}
                                        required
                                        disabled={isFormDisabled}
                                        readonly
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("alt_mobile") ? "border border-danger rounded p-1" : ""}>
                                    <MyMobile
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Mobile Number"}
                                        name={"alt_mobile"}
                                        placeholder={"Enter alternate mobile"}
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>

                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("email") ? "border border-danger rounded p-1" : ""}>
                                    <MyEmail
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Email"}
                                        name={"email"}
                                        placeholder={"Enter email"}
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("full_address") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Full Address"
                                        name="full_address"
                                        placeholder="Enter full address"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <h5 className="my-3">{"Operational Details"}</h5>
                                <Col md="4">
                                <div className={isRejected("start_time") ? "border border-danger rounded p-1" : ""}>
                                    <DateComponent
                                        register={register("start_time", { required: "This field is required" })}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Open Time"
                                        name="start_time"
                                        placeholder="start time"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>

                                <Col md="4">
                                <div className={isRejected("end_time") ? "border border-danger rounded p-1" : ""}>
                                    <DateComponent
                                        register={register("end_time", { required: "This field is required" })}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Closing Time"
                                        name="end_time"
                                        placeholder="end time"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>

                                <Col md="4" className={`mt-2`}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Longitude"}
                                        name={"longitude"}
                                        placeholder={"Enter longitude "}
                                        required
                                        // min={1}
                                        // max={3}
                                        disabled={isFormDisabled}
                                    />
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Latitude"}
                                        name={"latitude"}
                                        placeholder={"Ente latitude "}
                                        required
                                        // min={1}
                                        // max={3}
                                        disabled={isFormDisabled}
                                    />
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("min_order_value") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Minimum Order Value"}
                                        name={"min_order_value"}
                                        placeholder={"Enter minimum order value"}
                                        required
                                        // min={1}
                                        // max={3}
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("delivery_charges") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Delivery Charges"}
                                        name={"delivery_charges"}
                                        placeholder={"Enter delivery charges"}
                                        required
                                        // min={1}
                                        // max={2}
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md={4} className={`mt-2`}>
                                    {/* <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Accepted Payment Modes"}
                    name={"payment_modes"}
                    placeholder={"Select payment modes"}
                    required
                    multi
                    options={watch("paymentModeDD")}
                    disabled={isFormDisabled}
                  /> */}
                                </Col>

                                <h5 className="my-3">{"Medicine & Bank Documents"}</h5>

                                <Col md="4">
                                <div className={isRejected("account_holder_name") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Bank Account Holder name"
                                        name="account_holder_name"
                                        placeholder="Enter bank account holder name"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4">
                                <div className={isRejected("account_no") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Account No"
                                        name="account_no"
                                        placeholder="Enter bank no"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4">
                                <div className={isRejected("upi_id") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="UPI ID"
                                        name="upi_id"
                                        placeholder="Enter upi id"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="4" className={`mt-2`}>
                                <div className={isRejected("ifsc") ? "border border-danger rounded p-1" : ""}>
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="IFSC Code"
                                        name="ifsc"
                                        placeholder="Enter ifsc code"
                                        required
                                        disabled={isFormDisabled}
                                    />
                                    </div>
                                </Col>
                                <Col md="2" className={`mt-2`}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="drug_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"Drug License Docs."}
                                        errors={errors}
                                        register={register}
                                        image={"drug_img"}
                                        image_url={"drug_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        required
                                        validateDoc
                                        approve={mode === "Approval" ? true : false}
                                        size={2048}
                                    />
                                </Col>
                                {/* <Col md="2">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="catalog_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Drug Catalog"}
                    errors={errors}
                    register={register}
                    image={"catalog_img"}
                    image_url={"catalog_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col> */}
                                <Col md="2" className={`mt-2`}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="fssai_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"FSSAI License (Food li.)"}
                                        errors={errors}
                                        register={register}
                                        image={"fssai_img"}
                                        image_url={"fssai_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        required
                                        validateDoc
                                        approve={mode === "Approval" ? true : false}
                                        size={2048}
                                    />
                                </Col>
                                <Col md="3" className={`mt-2`}>
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="cheque_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"Cancelled Cheque / Bank Passbook"}
                                        errors={errors}
                                        register={register}
                                        image={"cheque_img"}
                                        image_url={"cheque_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        required
                                        validateDoc
                                        approve={mode === "Approval" ? true : false}
                                        size={2048}
                                    />
                                </Col>
                                {/* <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Cancellation/Return Policy"}
                    name={"cancellation_policy"}
                    placeholder={"Enter cancellation / return policy"}
                    required
                    // min={5}
                    // max={500}
                    cols={2}
                    row={2}
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                            </Row>
                            {mode == "Approval" && (
                                <Col md="12" className={`mt-2`}>
                                    <MyTextArea
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Remark"}
                                        name={"remark"}
                                        placeholder={"Reason for approval/rejection"}
                                        required
                                        // min={5}
                                        // max={500}
                                        cols={2}
                                        row={2}
                                    />
                                </Col>
                            )}
                            {mode == "Approval" && (
                                <>
                                    <Row>
                                        <div className="d-flex">
                                            {/* <div className="form-group" style={{ marginTop: "31px" }}>
                                                <Button
                                                    color="primary"
                                                    size="md"
                                                    type="submit"
                                                    onClick={() => setActionType("approve")}
                                                    disabled={isLoading || watch("objectionKeys")?.length > 0} // Disable if already rejected
                                                >
                                                    {isLoading ? <Spinner size="sm" color="light" /> : "Approve Pharmacy"}
                                                </Button>

                                            </div> */}

                                            {/* <div className="form-group mx-2" style={{ marginTop: "31px" }}>
                                                <Button
                                                    // disabled={isLoading || watch("objectionKeys")?.length <= 0} // Disable if already rejected
                                                    color="primary"
                                                    size="md"
                                                    type="submit"
                                                    onClick={() => setActionType("changeRequest")}
                                                >
                                                    {isLoading ? <Spinner size="sm" color="light" /> : "Decline"}
                                                </Button>
                                            </div> */}
                                        </div>
                                    </Row>
                                </>
                            )}
                            {mode == "Add" && (
                                <Row>
                                    <div className="d-flex">
                                        <div className="form-group" style={{ marginTop: "31px" }}>
                                            {/* <Button size={"md"} color={"primary"} type="submit" onClick={() => setValue("actionType", "add")}>
                        Add
                      </Button> */}
                                        </div>
                                    </div>
                                </Row>
                            )}
                            <Button color="primary" type="submit">
                                {mode === "Approval" ? "Approve" : "Update"}
                            </Button>
                        </Form>
                    </PreviewAltCard>
                </Block>
            </Content>

            <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
        </>
    );
};

export default PharmacyDetailFormEdit;
